import React from "react";


export default function NoPage() {
  return (
    <>
      <h1>Error 404: Not found</h1>
    </>
  );
}